









import { Vue, Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
@Component
export default class GachaChaTitleSection extends Vue {
  @Getter("titleSection") titleSection!: object;
  @Getter("title") getterTitle!: string;
}
